export default __webpack_public_path__ + "static/media/image-ph-health-alarm-w.a78a09e8.png";